<template>
  <div class="answer-note" v-if="Parses[page]">
    <div class="parsing-title">
      <span style="margin-right: 5px" class="pinspan"></span>本题笔记
    </div>

    <aside>
      <p>
        <el-input
          type="textarea"
          v-model="noteValue"
          maxlength="2000"
          rows="5"
          placeholder="请输入笔记内容"
          show-word-limit
        ></el-input>
      </p>
      <el-button
        type="primary"
        size="small"
        @click="addnote(notesLists[page - 1].id)"
        >保存</el-button
      >
    </aside>
    <div class="answer-note-list" v-if="notesLists.length !== 0">
      <div
        class="note-list"
        v-for="(vv, kk) in notesLists[page - 1].note"
        :key="vv.id"
      >
        <div class="note-list-tit">
          <div class="note-list-photo">
            <el-avatar :size="50" :src="vv.image"></el-avatar>
          </div>
          <div class="note-list-info">
            <div>
              <p style="margin-top: 4px">{{ vv.nickname }}</p>
              <p>{{ vv.create_time }}</p>
            </div>

            <div style="text-align: right">
              <button
                class="note-list-praise"
                :class="{ sun: vv.on_praise == 1 }"
                @click="praiseNotes($event, vv.id, kk)"
              >
                {{ vv.praise }}
              </button>
              <button
                v-show="vv.user_id == userid"
                class="note-list-dete"
                title="删除"
                @click="deleteNote(vv.id, user_id)"
              >
                删除
              </button>
            </div>
          </div>
        </div>
        <div class="note-list-text">
          <pre>{{ vv.content }}</pre>
        </div>
      </div>
      <!-- <button class="answer-list-more" v-show="notes && notes.length>4"
								@click="loadMoreNotes()">加载更多笔记</button> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["notes", "page", "Parses", "notesList", "subid"],
  data() {
    return {
      noteValue: "",
      userid: "",
      userInfo: "",
      notesLists: this.notesList,
      likeState: [],
      userNoteId: "",
    };
  },

  created() {
    console.log(this.notesLists);
    this.userid = localStorage.getItem("userId");
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    console.log(this.userInfo);
  },
  mounted() {},
  methods: {
    // 数组数据
    setParses() {
      this.$set(this.Parses, 0, this.Parses[0]);

      console.log(this.Parses);
      // this.$forceUpdate
      let tiem = setTimeout(() => {
        this.notesLists = this.notesList;
      
      
        if (this.notesLists[this.page - 1]?.note) {
          for (let item of this.notesLists[this.page - 1].note) {
            item.click = false;

            let sum = parseInt(item.content.replace(/\s*/g, "").length / 54);
            let number = item.content.indexOf("\n");
            let nub = item.content.slice(0, 54);

            console.log(number, "循环");

            if (item.content.length > 54) {
              if (number != -1 && nub.indexOf("\n") != -1) {
                return;
              }
              for (let i = 1; i <= sum; i++) {
                let nm =
                  item.content.slice(0, 54 * i) +
                  "\n" +
                  item.content.slice(54 * i);
                item.content = nm;
              }
            }
          }
          console.log(this.notesLists[this.page - 1]);
        }
      }, 2000);
    },
    // 笔记格式转换
    noteFormat(note) {
      let that = this;
      for (let v of note) {
        //console.log(v)

        let sum = parseInt(v.content.replace(/\s*/g, "").length / 54);
        let number = v.content.indexOf("\n");
        console.log(number);
        if (v.content.length > 54) {
          if (number != -1) {
            return;
          }
          for (let i = 1; i <= sum; i++) {
            let nm =
              v.content.slice(0, 54 * i) + "\n" + v.content.slice(54 * i);
            v.content = nm;
          }
        }
      }
    },

    // 点赞
    praiseNotes(e, id, kk) {
      console.log(id);

      if (this.notesLists[this.page - 1].note[kk].click) {
        this.notesLists[this.page - 1].note[kk].praise--;

        this.$set(this.notesLists[this.page - 1].note[kk], "click", false);
        console.log(this.notesLists[this.page - 1].note[kk].click);
      } else {
        this.notesLists[this.page - 1].note[kk].praise++;

        this.$set(this.notesLists[this.page - 1].note[kk], `click`, true);
        console.log(this.notesLists[this.page - 1].note[kk].click, kk);
      }

      this.$api.userNotePraise({ id: id }).then((res) => {});
    },
    // 删除笔记
    deleteNote(id_, id) {
      this.$confirm("您确定要删除笔记吗？?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.delUserNote({ id: id_ }).then((res) => {
            let setnotes = new Set(this.notesLists[this.page - 1].note);
            setnotes.forEach((item) => {
              if (item.user_id == this.userInfo.id) {
                setnotes.delete(item);
              }
            });
            this.notesLists[this.page - 1].note = Array.from(setnotes);
            this.$set(this.notesLists, 0, this.notesLists[0]);
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 时间搓
    timesSeconds() {
      var date = new Date();
      const Y = date.getFullYear() + "-";
      const M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      const D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var h = null;
      var m = null;
      var s = null;
      if (date.getHours()) {
        h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      } else {
        h = "00";
      }
      if (date.getMinutes()) {
        m =
          date.getMinutes() < 10
            ? ":" + "0" + date.getMinutes()
            : ":" + date.getMinutes();
      } else {
        m = ":00";
      }
      if (date.getSeconds()) {
        s =
          date.getSeconds() < 10
            ? ":" + "0" + date.getSeconds()
            : ":" + date.getSeconds();
      } else {
        s = ":00";
      }
      return Y + M + D + "\xa0\xa0\xa0" + h + m + s;
    },

    // 保存笔记
    addnote(id) {
      //console.log(this.usernot)
      if (
        this.noteValue.trim() == "" ||
        this.noteValue.trim() == this.usernot
      ) {
        this.$message({
          type: "error",
          message:
            this.noteValue.trim() == ""
              ? "笔记不能为空！"
              : "两次笔记不能一样哦",
          showClose: true,
        });
        return;
      }
      this.$api
        .setUserNote({
          list_id: id,
          sub_id: this.subid,
          content: this.noteValue,
          type: 3,
        })
        .then((res) => {
          // //console.log(res);
          this.$message.success("笔记添加成功");

          let setnotes = new Set(this.notesLists[this.page - 1].note);
          setnotes.forEach((item) => {
            if (item.user_id == this.userInfo.id) {
              setnotes.delete(item);
            }
          });
          let valueformat = this.noteValue;

          let nub = valueformat.slice(0, 54);
          let sum = parseInt(valueformat.replace(/\s*/g, "").length / 53);
          let number = valueformat.indexOf("\n");
          console.log(number);
          if (valueformat.length > 54) {
            if (number != -1 && nub.indexOf("\n") != -1) {
            } else {
              for (let i = 1; i <= sum; i++) {
                let nm =
                  valueformat.slice(0, 53 * i) +
                  "\n" +
                  valueformat.slice(53 * i);
                valueformat = nm;
              }
            }
          }

          setnotes.add({
            content: valueformat,
            image: this.userInfo.image,
            list_id: id,
            nickname: this.userInfo.nickname,
            praise: 0,
            user_id: this.userInfo.id,
            create_time: this.timesSeconds(),
            id: res.data.id,
          });
          this.notesLists[this.page - 1].note = Array.from(setnotes);
          this.$set(this.notesLists, 0, this.notesLists[0]);
          console.log(this.notesLists[this.page - 1].note);
          this.noteValue = "";

          // this.notesList[page-1].note = [...this.notesList[page-1].note,...{}]

          //console.log(id)
        });
    },
  },
};
</script>

<style scoped lang = 'less'>
</style>